// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ContractCompanySearchResponse

import { hydrateContractCompanyItem, type ContractCompanyItem, type ContractCompanyItemApiResponse } from './contractCompanyItem.gen';

export type ContractCompanySearchApiResponse = {
	results: ContractCompanyItemApiResponse[];
	error: string | null;
};

export type ContractCompanySearch = {
	results: ContractCompanyItem[];
	error: string | null;
};

export function hydrateContractCompanySearch(data: ContractCompanySearchApiResponse): ContractCompanySearch {
	return {
		...data,
		results: data.results.map(hydrateContractCompanyItem),
	};
}